/** @private */
export function isValidDate(day) {
    return !isNaN(day.getTime());
}
//# sourceMappingURL=isValidDate.js.map